import ErrorIcon from '@mui/icons-material/ErrorOutline';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import WarningIcon from '@mui/icons-material/ReportGmailerrorred';
import GenericIcon from '@mui/icons-material/Warning';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import useResponsive from '@/hooks/useResponsive';

interface AlertBoxProps {
  type?: 'error' | 'warning' | 'success' | 'generic';
  children: React.ReactNode;
  direction?: string;
  inDrawer?: boolean;
}

const icons = {
  error: <ErrorIcon color="secondary" fontSize="large" />,
  warning: <WarningIcon fontSize="large" sx={{ color: '#f6b75f' }} />,
  success: <PriorityHighIcon color="primary" fontSize="large" />,
  generic: <GenericIcon color="secondary" fontSize="large" />,
};

const AlertBox = ({
  type = 'error',
  children,
  direction = 'row',
  inDrawer = false,
}: AlertBoxProps) => {
  const theme = useTheme();
  const isMobile = useResponsive('down', 'sm');
  const isTablet = useResponsive('between', 'lg', 'xl');

  const bgColors = {
    error: theme.palette.error.lighter,
    warning: '#fcebb1ad',
    success: 'rgb(217 237 223)',
    generic: 'rgb(213 238 233)',
  };

  const fontColors = {
    error: theme.palette.secondary.main,
    warning: '#f7b731',
    success: theme.palette.primary.main,
    generic: theme.palette.secondary.main,
  };

  return (
    <Box
      sx={{
        padding: { xxs: theme.spacing(2), sm: theme.spacing(2), xl: theme.spacing(3) },
        borderRadius: '10px',
        backgroundColor: bgColors[type],
        display: 'flex',
        flexDirection: inDrawer && isTablet ? 'column' : direction,
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        color: fontColors[type],
      }}
    >
      {icons[type]}
      <Divider
        orientation={
          isMobile
            ? 'horizontal'
            : inDrawer && isTablet
              ? 'horizontal'
              : direction === 'column'
                ? 'horizontal'
                : 'vertical'
        }
        flexItem
        sx={{
          margin: direction === 'column' ? `${theme.spacing(2)} 0` : `0 ${theme.spacing(2)}`,
          [theme.breakpoints.down('sm')]: {
            margin: `${theme.spacing(2)} 0`,
          },
        }}
      />
      {children}
    </Box>
  );
};

export default AlertBox;
